export default "__VITE_ASSET__0cca0ed9__"